import { isContentEmpty } from "@congrs/utils";

import { renderBadgePdf, useGetBadgeTemplates } from "../../api/badges";
import { useGetAllCampaigns } from "../../api/campaigns";
import { printTicket } from "../../utils/printTicket";

// What a ticket row can do besides edit and delete, shared by the tickets
// table and the tickets preview so the two can't drift apart.

/**
 * Prints a ticket: the event's default badge when it has one, the plain
 * ticket otherwise (or when the badge fails to render).
 */
export function usePrintTicket(eventId) {
  const { data: badgeTemplates } = useGetBadgeTemplates({ eventId });
  const defaultBadgeId = badgeTemplates?.find((b) => b.isDefault)?.id;

  return async (ticket) => {
    if (defaultBadgeId) {
      try {
        const { url } = await renderBadgePdf({
          badgeId: defaultBadgeId,
          ticketId: ticket.id,
        });
        window.open(url, "_blank");
        return;
      } catch {
        printTicket(ticket);
        return;
      }
    }
    printTicket(ticket);
  };
}

/** Whether the event has a campaign with content, to send to one ticket. */
export function useHasAvailableCampaigns(eventId) {
  const { data: campaignsData } = useGetAllCampaigns({
    eventId,
    page: 1,
    limit: 100,
  });
  return (campaignsData?.data ?? []).some(
    (campaign) => !isContentEmpty(campaign.contentHtml)
  );
}
